module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"popup-create-form\"> <button type=\"button\" class=\"btn btn-blue showPopup\">")
    ; __append(escapeFn( locals.title ))
    ; __append("</button> <div class=\"panel\"> <h5> ")
    ; __append(escapeFn( locals.title ))
    ; __append(" <button type=\"button\" class=\"close\" data-dismiss=\"modal\" tabindex=\"-1\"><span>&times;</span></button> </h5> <form> ")
    ;  _.each(locals.dropdownSelections, function(dropdownSelection, idx) { 
    ; __append(" <div class=\"form-group\"> <div id=\"")
    ; __append(escapeFn( locals.computeSelectionViewId(idx) ))
    ; __append("\"></div> </div> ")
    ;  }); 
    ; __append(" ")
    ;  _.each(locals.formFields, function(formField) { 
    ; __append(" <div class=\"form-group\"> ")
    ;  if (formField.label) { 
    ; __append(" <label>")
    ; __append(escapeFn( formField.label ))
    ; __append("</label> ")
    ;  } 
    ; __append(" <input name=\"")
    ; __append(escapeFn( formField.paramKey ))
    ; __append("\" value=\"")
    ; __append(escapeFn( formField.defaultValue ))
    ; __append("\" placeholder=\"")
    ; __append(escapeFn( formField.placeholder))
    ; __append("\" type=\"")
    ; __append(escapeFn( formField.type ))
    ; __append("\" class=\"form-control form-control-md\"> </div> ")
    ;  }); 
    ; __append(" <button class=\"btn btn-blue\" type=\"submit\">Create ")
    ; __append(escapeFn( locals.objectName ))
    ; __append("</button> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/popup_create_form/template.ejs
// module id = 861
// module chunks = 1